module.exports = __webpack_public_path__ + "media/site/images/products/saas_ceodash@2x-854ca30b66d7bdb3c62a46434fba0873.png";